interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className = '' }: SkeletonProps) {
  return (
    <div className={`animate-pulse bg-iron-800 ${className}`} />
  );
}

export function AuctionCardSkeleton() {
  return (
    <div className="bg-iron-900 border border-iron-800">
      <Skeleton className="h-64" />
      <div className="p-6 space-y-4">
        <Skeleton className="h-2 w-1/3" />
        <Skeleton className="h-4 w-3/4" />
        <div className="h-px bg-iron-800" />
        <div className="grid grid-cols-2 gap-4">
          <Skeleton className="h-8" />
          <Skeleton className="h-8" />
        </div>
        <Skeleton className="h-10" />
      </div>
    </div>
  );
}